import React from 'react';
import { Tag } from 'antd';

interface CustomerTypeProps {
  value: string;
}

const CustomerType: React.FC<CustomerTypeProps> = ({ value }) => {
  let color = 'blue';

  switch(value) {
    case 'Doanh nghiệp':
      color = 'green';
      break;

    case 'Cá nhân':
      color = 'blue';
      break;

    default:
      color = 'gray';
      break;
  }

  return <Tag color={color}>{value}</Tag>;
};

export default CustomerType;
